import { map } from 'rxjs/operators';
import { Action, ActionReducerMap, createReducer, MetaReducer, on } from '@ngrx/store';

import * as Test9Actions from '../actions/test9.actions';
import { environment } from '../../environments/environment';
import { Movie } from '../../models/movie';

export const test9FeatureKey = 'test9';

export interface Test9State {

  movies: any[];
  loading: boolean;
  error: string;

}

export const initialState: Test9State = {

  movies: [],
  loading: false,
  error: '',

}

export const test9Reducer = createReducer(

  initialState,

  //Load
  // on(Test9Actions.loadMovies, (state) => ({ ...state, loading: true })),
  on(Test9Actions.loadMovies, (state) => {

    return {
      ...state,
      loading: true,
      movies: [],
      error: ""
    };

  }),
  // on(Test9Actions.loadMoviesSuccess, (state, { data }) => ({ ...state, loading: false, movies: data })),
  on(Test9Actions.loadMoviesSuccess, (state, { data }) => {

    return {
      ...state,
      loading: false,
      movies: data,
      error: ""
    };

  }),
  on(Test9Actions.loadMoviesFailure, (state, { error }) => ({ ...state, loading: false, error: error })),

  //Add
  on(Test9Actions.addMovie, (state) => ({ ...state, loading: true })),
  on(Test9Actions.addMovieSuccess, (state, data: any) => {

    let oldMoviesAndNewOne: Movie[] = [...state.movies, data.movie];
    return {
      ...state,
      loading: false,
      movies: oldMoviesAndNewOne,
      error: ""
    };

  }),
  on(Test9Actions.addMovieFailure, (state, { error }) => ({ ...state, loading: false, error: error })),

  //update
  on(Test9Actions.updateMovie, (state) => ({ ...state, loading: true })),

  on(Test9Actions.updateMovieSuccess, (state, data: any) => {

    let moviesAfterUpdate = state.movies.map((m: Movie) => {

      if (m.Id === data.movie.Id) {

        return data.movie; //for this id return the movie received via data

      }

      return m;

    });


    return {
      ...state,
      loading: false,
      movies: moviesAfterUpdate,
      error: ""
    };

  }),
  on(Test9Actions.updateMovieFailure, (state, { error }) => ({ ...state, loading: false, error: error })),

  //delete
  on(Test9Actions.deleteMovie, (state) => ({ ...state, loading: true })),

  on(Test9Actions.deleteMovieSuccess, (state, data: any) => {


    let movieToRemove: Movie = data.movie;

    let moviesAfterDelete = state.movies.filter((movie) => movie.Id !== movieToRemove.Id)


    return {
      ...state,
      loading: false,
      movies: moviesAfterDelete,
      error: ""
    };

  }),
  on(Test9Actions.deleteMovieFailure, (state, { error }) => ({ ...state, loading: false, error: error })),


);
//using config files for that
export const metaReducers: MetaReducer<Test9State>[] = [];

//using config files for that
//export const metaReducers: MetaReducer<Test9State>[] = !environment.production ? [] : [];
